<div>
  <h2>Выберите способ получения</h2>

  <div #tabs *ngIf="receiptTypes$ | async as receiptTypes; else skeleton" class="buttons">
    <button
      class="variant"
      [ngClass]="{ active: (activeModeId$ | async) === receiptType.code }"
      (click)="setActive(receiptType.code)"
      [attr.data-testid]="receiptType.code + 'Btn'"
      *ngFor="let receiptType of receiptTypes"
    >
      <cx-icon [type]="variantIcon[receiptType.code]"></cx-icon>
      {{ receiptType.description }}
    </button>
  </div>
  <ng-template #skeleton>
    <div class="buttons">
      <div class="skelet"></div>
      <div class="skelet"></div>
    </div>
  </ng-template>
</div>
